


//서브 카테고리을 선택한 경우, 페이지 스크롤 위치를 서브카테고리로 위치시킨다.
$(document).ready(function() {

  //상품이미지들 LazyLoad
  $("img.lazy").lazyload();


  $(window).scroll(function () {

    //console.log($(window).scrollTop())



    if ($(window).scrollTop() == 0) {
      $("ul.cl_category_list li").removeClass("cl_selected");
    }


    //스크롤 변화에 따른 카테고리 선택 적용
    $("div[id='id_category_title']").each(function(){

      var srcollTop = $(this).offset().top;


      if(srcollTop < $(window).scrollTop()+($(window).height()/6) )
      {
        var  cateHandle = $(this).attr("category_handle");
        $("ul.cl_category_list li").removeClass("cl_selected");
        $("ul.cl_category_list li[category_handle=" + cateHandle + "]").addClass("cl_selected");
      }
    });

    scrollToCenterSelectedCategory();

  });
});






//해당 서브카테고리 지점으로 스크롤이동
function onSelectSubcategory(li_obj)
{
  var cateGroupObj = $('.cl_category_group_v2');

  $("ul.cl_category_list li").removeClass("cl_selected");

  $(li_obj).addClass("cl_selected");
  var  cateHandle = $(li_obj).attr("category_handle");


  var position = $("div[category_handle="+cateHandle+"]").offset();

  var cateGroupHeight = cateGroupObj.outerHeight();

  if(!cateGroupObj.hasClass("cl_fixed"))
  {
    cateGroupHeight = (cateGroupHeight * 1) + 0;
  }

  window.scroll(0,position.top - cateGroupHeight);


}

//선택된 카테고리 메뉴의 좌우 스크롤 포지션 변경(모바일화면에서 선택된 카테고리메뉴가 화면내에 보이도록)
function scrollToCenterSelectedCategory(){

  var cateGroupObj = $('.cl_category_group_v2');
  var selectedCateObj = $("ul.cl_category_list li.cl_selected");

  if(typeof selectedCateObj.position() === 'undefined') return;

  cateGroupObj.scrollLeft(cateGroupObj.scrollLeft() + selectedCateObj.position().left - ($(window).width()/2) + (selectedCateObj.width()/2) );


}
